import { FC } from "react"
import t from "../translations/i18n";
import Select from "react-select";
import { Option } from "../types/Option";
import { ActionMeta } from "react-select";

export interface LanguageInputProps {
    placeholder: string;
    value: Option | null;
    onChange: (value: Option | null, actionMeta: ActionMeta<Option>) => void;
}

export const LanguageInput: FC<LanguageInputProps> = (props: LanguageInputProps) => {

    const options = [
        {label: t("lang.afrikaans"), value:	"af" },
        {label: t("lang.albanian"), value:	"sq" },
        {label: t("lang.amharic"), value:	"am" },
        {label: t("lang.arabic"), value:	"ar" },
        {label: t("lang.armenian"), value:	"hy" },
        {label: t("lang.assamese"), value:	"as" },
        {label: t("lang.azerbaijani"), value: "az" },
        {label: t("lang.bangla"), value:	"bn" },
        {label: t("lang.bashkir"), value:	"ba" },
        {label: t("lang.basque"), value:	"eu" },
        {label: t("lang.bhojpuri"), value:	"bh" },
        {label: t("lang.bodo"), value:	"br" },
        {label: t("lang.bosnian"), value: "bs" },
        {label: t("lang.bulgarian"), value:	"bg" },
        {label: t("lang.cantonese"), value: "yue" },
        {label: t("lang.catalan"), value:	"ca" },
        {label: t("lang.chinese-simplified"), value: "zh-Hans" },
        {label: t("lang.chinese-traditional"), value: "zh-Hant" },
        {label: t("lang.chiShona"), value:	"sn" },
        {label: t("lang.croatian"), value:	"hr" },
        {label: t("lang.czech"), value:	"cs" },
        {label: t("lang.danish"), value:	"da" },
        {label: t("lang.dari"), value:	"pr" },
        {label: t("lang.divehi"), value:	"dv" },
        {label: t("lang.dogri"), value:	"do" },
        {label: t("lang.dutch"), value:	"nl" },
        {label: t("lang.english"), value:	"en" },
        {label: t("lang.estonian"), value:	"et" },
        {label: t("lang.faroese"), value:	"fo" },
        {label: t("lang.fijian"), value:	"fj" },
        {label: t("lang.filipino"), value:	"fi" },
        {label: t("lang.finnish"), value:	"fi" },
        {label: t("lang.french"), value:	"fr" },
        {label: t("lang.french-canada"), value: "fr-ca" },
        {label: t("lang.galician"), value:	"gl" },
        {label: t("lang.georgian"), value:	"ka" },
        {label: t("lang.german"), value:	"de" },
        {label: t("lang.greek"), value:	"el" },
        {label: t("lang.gujarati"), value:	"gu" },
        {label: t("lang.haitian"), value: "Cr" },
        {label: t("lang.hausa"), value:	"ha" },
        {label: t("lang.hebrew"), value:	"he" },
        {label: t("lang.hindi"), value:	"hi" },
        {label: t("lang.hmong"), value: "Da" },
        {label: t("lang.hungarian"), value:	"hu" },
        {label: t("lang.icelandic"), value:	"is" },
        {label: t("lang.igbo"), value:	"ig" },
        {label: t("lang.indonesian"), value:	"id" },
        {label: t("lang.inuinnaqtun"), value:	"ik" },
        {label: t("lang.inuktitut"), value:	"iu" },
        {label: t("lang.inuktitut-latin"), value: "iu-Latn" },
        {label: t("lang.irish"), value:	"ga" },
        {label: t("lang.italian"), value:	"it" },
        {label: t("lang.japanese"), value:	"ja" },
        {label: t("lang.kannada"), value:	"kn" },
        {label: t("lang.kashmiri"), value:	"ks" },
        {label: t("lang.kazakh"), value:	"kk" },
        {label: t("lang.khmer"), value:	"km" },
        {label: t("lang.kinyarwanda"), value:	"rw" },
        {label: t("lang.klingon"), value:	"tlh-Latn" },
        {label: t("lang.klingon-plqad"), value: "tlh-Piqd" },
        {label: t("lang.konkani"), value:	"go" },
        {label: t("lang.korean"), value:	"ko" },
        {label: t("lang.kurdish-central"), value: "ku" },
        {label: t("lang.kurdish-northern"), value: "kmy" },
        {label: t("lang.kyrgyz"), value: "ky" },
        {label: t("lang.lao"), value:	"lo" },
        {label: t("lang.latvian"), value:	"lv" },
        {label: t("lang.lithuanian"), value:	"lt" },
        {label: t("lang.lingala"), value:	"ln" },
        {label: t("lang.lower-sorbian"), value: "dsb" },
        {label: t("lang.luganda"), value:	"lu" },
        {label: t("lang.macedonian"), value:	"mk" },
        {label: t("lang.maithili"), value:	"ma" },
        {label: t("lang.malagasy"), value:	"mg" },
        {label: t("lang.malay"), value: "ms" },
        {label: t("lang.malayalam"), value:	"ml" },
        {label: t("lang.maltese"), value:	"mt" },
        {label: t("lang.maori"), value:	"mi" },
        {label: t("lang.marathi"), value:	"mr" },
        {label: t("lang.mongolian-cyrillic"), value: "mg-Cyrl" },
        {label: t("lang.mongolian-traditional"), value: "mg-Mong" },
        {label: t("lang.myanmar"), value:	"my" },
        {label: t("lang.nepali"), value:	"ne" },
        {label: t("lang.norwegian"), value:	"nb" },
        {label: t("lang.nyanja"), value:	"ny" },
        {label: t("lang.odia"), value:	"or" },
        {label: t("lang.pashto"), value:	"ps" },
        {label: t("lang.persian"), value:	"fa" },
        {label: t("lang.polish"), value:	"pl" },
        {label: t("lang.portuguese-brazil"), value: "pt-br" },
        {label: t("lang.portuguese-portugal"), value: "pt-pt" },
        {label: t("lang.punjabi"), value:	"pa" },
        {label: t("lang.queretaro"), value: "Ot" },
        {label: t("lang.romanian"), value:	"ro" },
        {label: t("lang.rundi"), value:	"ru" },
        {label: t("lang.russian"), value:	"ru" },
        {label: t("lang.samoan"), value: "sm" },
        {label: t("lang.serbian-cyrillic"), value: "sr-Cyrl" },
        {label: t("lang.serbian-latin"), value: "sr-Latn" },
        {label: t("lang.sesotho"), value:	"st" },
        {label: t("lang.sesotho"), value: "sa" },
        {label: t("lang.setswana"), value:	"tn" },
        {label: t("lang.sindhi"), value:	"sd" },
        {label: t("lang.sinhala"), value:	"si" },
        {label: t("lang.slovak"), value:	"sk" },
        {label: t("lang.slovenian"), value:	"sl" },
        {label: t("lang.somali"), value: "so" },
        {label: t("lang.spanish"), value:	"es" },
        {label: t("lang.swahili"), value: "sw" },
        {label: t("lang.swedish"), value:	"sv" },
        {label: t("lang.tahitian"), value:	"ty" },
        {label: t("lang.tamil"), value:	"ta" },
        {label: t("lang.tatar"), value: "tt" },
        {label: t("lang.telugu"), value:	"te" },
        {label: t("lang.thai"), value:	"th" },
        {label: t("lang.tibetan"), value:	"bo" },
        {label: t("lang.tigrinya"), value:	"ti" },
        {label: t("lang.tongan"), value:	"to" },
        {label: t("lang.turkish"), value:	"tr" },
        {label: t("lang.turkmen"), value: "tk" },
        {label: t("lang.ukrainian"), value:	"uk" },
        {label: t("lang.upper-sorbian"), value: "hsb" },
        {label: t("lang.urdu"), value:	"ur" },
        {label: t("lang.uyghur"), value: "ug" },
        {label: t("lang.uzbek"), value: "uz" },
        {label: t("lang.vietnamese"), value:	"vi" },
        {label: t("lang.welsh"), value:	"cy" },
        {label: t("lang.xhosa"), value:	"xh" },
        {label: t("lang.yoruba"), value:	"yo" },
        {label: t("lang.yucatec-maya"), value: "yua" },
        {label: t("lang.zulu"), value:	"zu" }
    ];

    options.sort((a, b) => a.label.localeCompare(b.label));

    return (
        <Select
            className="text-xs text-tertiarydark w-full"
            placeholder={props.placeholder}
            options={options}
            onChange={props.onChange}
            value={props.value}
        />
    );
}